import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDashboardCount } from "../redux/actions/DashboardActions";
import styled from "styled-components";
const Dashboard = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
  } = useSelector((state) => state);
  const {
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);

  useEffect(() => {
    dispatch(getDashboardCount(auth?.token));
  }, [auth.token]);
  const { dashboardCount } = useSelector((state) => state.dashboardReducer);

  const getSum = (arr) => {
    return arr?.reduce((prev, curr) => (prev += parseInt(curr.amount)), 0);
  };

  console.log(dashboardCount);

  return (
    <Wrapper>
      <div className="py-4">
        <div class="page-header pb-3">
          <h4 class="page-title">Dashboard</h4>
        </div>
        <div class="row pb-3">
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 mt-2">
            <div class="card">
              <div class="card-body w-100">
                <div class="d-flex justify-content-between">
                  <div>
                    <h5 className="text-black pb-2">
                      <b>Destinations</b>
                    </h5>
                  </div>
                  <h3 class="text-info fw-bold">
                    {dashboardCount?.consultantCount}
                  </h3>
                </div>
                <div class="progress progress-sm">
                  <div
                    class="progress-bar bg-info w-75"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"    
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <p class="text-muted mb-0 py-3 fs-5">Monthly</p>
                  <p class="text-muted mb-0 py-3 fs-5">75%</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-3 mt-2">
            <div class="card">
              <div class="card-body w-100">
                <div class="d-flex justify-content-between">
                  <div>
                    <h5 className="text-black pb-2">
                      <b>Happy Users</b>
                    </h5>
                  </div>
                  <h3 class="text-info fw-bold">{dashboardCount?.userCount}</h3>
                </div>
                <div class="progress progress-sm">
                  <div
                    class="progress-bar bg-info w-75"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <p class="text-muted mb-0 py-3 fs-5">Monthly</p>
                  <p class="text-muted mb-0 py-3 fs-5">75%</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-3 mt-2">
            <div class="card">
              <div class="card-body w-100">
                <div class="d-flex justify-content-between">
                  <div>
                    <h5 className="text-black pb-2">
                      <b> Bookings </b>
                    </h5>
                  </div>
                  <h3 class="text-success fw-bold">
                    {dashboardCount?.bookedAppointment}
                  </h3>
                </div>
                <div class="progress progress-sm">
                  <div
                    class="progress-bar bg-success w-75"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <p class="text-muted mb-0 py-3 fs-5">Monthly</p>
                  <p class="text-muted mb-0 py-3 fs-5">75%</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 mt-2">
            <div class="card">
              <div class="card-body w-100">
                <div class="d-flex justify-content-between">
                  <div>
                    <h5 className="text-black pb-2">
                      <b>Flights </b>
                    </h5>
                  </div>
                  <h3 class="text-danger fw-bold">
                    {dashboardCount?.bookedAudioAppointment}
                  </h3>
                </div>
                <div class="progress progress-sm">
                  <div
                    class="progress-bar bg-danger w-75"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <p class=" text-muted mb-0 py-3 fs-5">Monthly</p>
                  <p class="text-muted mb-0 py-3 fs-5">70%</p>
                </div>
              </div>
            </div>
          </div>
          {/* <div class="col-12 col-sm-6 col-md-6 mt-2 mt-3">
            <div class="card">
              <div class="card-body w-100">
                <div class="d-flex justify-content-between">
                  <div>
                    <h5 className="text-black pb-2">
                      <b>Video Call Booked</b>
                    </h5>
                  </div>
                  <h3 class="text-secondary fw-bold">
                    {dashboardCount?.bookedVideoAppointment}
                  </h3>
                </div>
                <div class="progress progress-sm">
                  <div
                    class="progress-bar bg-secondary w-75"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <p class="text-muted mb-0 py-3 fs-5">Monthly</p>
                  <p class="text-muted mb-0 py-3 fs-5">80%</p>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div class="col-12 col-sm-6 col-md-3 mt-3">
            <div class="card">
              <div class="card-body w-100">
                <div class="d-flex justify-content-between">
                  <div>
                    <h5 className="text-black pb-2">
                      <b>Total Revenue</b>
                    </h5>
                  </div>
                  <h3 class="text-secondary fw-bold">
                    {getSum(dashboardCount?.revenue)}
                  </h3>
                </div>
                <div class="progress progress-sm">
                  <div
                    class="progress-bar bg-secondary w-75"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <p class="text-muted mb-0 py-3 fs-5">Monthly</p>
                  <p class="text-muted mb-0 py-3 fs-5">80%</p>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div class="col-12 col-sm-6 col-md-3 mt-3">
            <div class="card">
              <div class="card-body w-100">
                <div class="d-flex justify-content-between">
                  <div>
                    <h5 className="text-black pb-2">
                      <b>Total Withdrawal</b>
                    </h5>
                  </div>
                  <h3 class="text-secondary fw-bold">
                    {getSum(dashboardCount?.withdrawal)}
                  </h3>
                </div>
                <div class="progress progress-sm">
                  <div
                    class="progress-bar bg-secondary w-75"
                    role="progressbar"
                    aria-valuenow="75"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <p class="text-muted mb-0 py-3 fs-5">Monthly</p>
                  <p class="text-muted mb-0 py-3 fs-5">80%</p>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </Wrapper>
  );
};

export default Dashboard;

const Wrapper = styled.div`
  .b,
  .strong,
  b,
  strong {
    font-weight: 600 !important;
  }
  h3 {
    font-size: 1.1625rem;
  }
  h5 {
    font-size: 1.5rem !important;
    line-height: 1.4;
  }
  .fw-bold {
    font-weight: 600 !important;
  }
  .progress.progress-sm {
    height: 8px;
  }
  .bg-success {
    background-color: #35cd3a !important;
  }
  .text-success {
    color: #35cd3a !important;
  }
  .bg-danger {
    background-color: #f3545d !important;
  }
  .text-danger {
    color: #f3545d !important;
  }
  .bg-secondary {
    background-color: #716aca !important;
  }
  .text-secondary {
    color: #716aca !important;
  }

  .card-body w-100{
    width: fit-content;
    height: 150px;
  }
  
  @media (min-width: 750px) and (max-width:1440px) {
    h5{
      font-size: 20px !important;
    }
  }

  @media screen and (max-width:1070px) {
    h5{
      font-size: 15px !important;
     }
    p{
      font-size: .975rem !important;
    } 
  }

  
  
`;
